import { Configuration } from "Configuration";
import { BaseService } from "./BaseService";
import { ReportContent, ReportExecution, ReportExport, ReportParameter, ReportsClient } from "./Client";

/**
 * Service for versions.
 * @hidden
 */
export class ReportService extends BaseService {
    /**
     * Get dms version info.
     * @param gridId Grid ID.
     * @param filterId Filter ID.
     * @param textBlockCategory TextBlockCategory.
     * @param commandOption CommandOption.
     */
    public getParameters(reportName: string): Promise<ReportParameter[]> {
        let client = new ReportsClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<ReportParameter[]>((resolve, reject) => {
                /* let xhr =*/ client.getParameters(
                    reportName,
                    (res) => {
                        resolve(res);
                    },
                    (exception, reason) => {
                        reject(exception);
                    }
                );
                // token.onCancelled((reason) => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }

    /**
     * Get dms version info.
     * @param gridId Grid ID.
     * @param filterId Filter ID.
     * @param textBlockCategory TextBlockCategory.
     * @param commandOption CommandOption.
     */
    public getContent(reportName: string, parameter: ReportExecution): Promise<ReportContent> {
        let client = new ReportsClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return this.handleResult(
            new Promise<ReportContent>((resolve, reject) => {
                /* let xhr =*/ client.getContent(
                    reportName,
                    parameter,
                    (res) => {
                        resolve(res);
                    },
                    (exception, reason) => {
                        reject(exception);
                    }
                );
                // token.onCancelled((reason) => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }

    public exportReport(reportName: string, parameter: ReportExecution, format: string): Promise<ReportExport> {
        let client = new ReportsClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return this.handleResult(
            new Promise<any>((resolve, reject) => {
                /* let xhr =*/ client.export(
                    reportName,
                    format,
                    parameter,
                    (res) => {
                        resolve(res);
                    },
                    (exception, reason) => {
                        reject(exception);
                    }
                );
                // token.onCancelled((reason) => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }
}
